module.exports = __webpack_public_path__ + "img/header-icon4.969b20f4.jpg";